// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  width: 100%;
  background-color: #ebebeb;
  display: flex;
  justify-content: space-between;
  padding: 10px 0px;
  border-bottom: 1px solid #dfdfdf;
  top: 0px;
  left:0;
  position: fixed;
  z-index: 999;
}
.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dashboard-logo {
  display: flex;
}
.landing-logo {
  cursor: pointer;
  object-fit: fill;
  height: 40px;
  width: auto;
}
.right-side-links {
  display: flex;
  align-items: center;
}
.user-item {
  display: flex !important;
  padding: 8px 10px !important;
  justify-content: flex-start !important;
}
.user-avtar {
  border: 2px solid #d7d7d7;
}
.user-avtar img {
  object-fit: cover;
}
p {
  margin-block-end: 0px;
  margin-block-start: 0px;
}
.insta-link {
  height: 24px;
  display: block;
}
@media (max-width: 767px) {
  .landing-logo {
    height: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/header/Header.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,gCAAgC;EAChC,QAAQ;EACR,MAAM;EACN,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,sCAAsC;AACxC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".header {\n  width: 100%;\n  background-color: #ebebeb;\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0px;\n  border-bottom: 1px solid #dfdfdf;\n  top: 0px;\n  left:0;\n  position: fixed;\n  z-index: 999;\n}\n.header-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.dashboard-logo {\n  display: flex;\n}\n.landing-logo {\n  cursor: pointer;\n  object-fit: fill;\n  height: 40px;\n  width: auto;\n}\n.right-side-links {\n  display: flex;\n  align-items: center;\n}\n.user-item {\n  display: flex !important;\n  padding: 8px 10px !important;\n  justify-content: flex-start !important;\n}\n.user-avtar {\n  border: 2px solid #d7d7d7;\n}\n.user-avtar img {\n  object-fit: cover;\n}\np {\n  margin-block-end: 0px;\n  margin-block-start: 0px;\n}\n.insta-link {\n  height: 24px;\n  display: block;\n}\n@media (max-width: 767px) {\n  .landing-logo {\n    height: 30px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
